import { Box, Divider, List, ListItem, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { navigateTypeState, Pages } from "states";

type Props = {
  pages: Pages;
  closeDrawer: Function;
};

export const SGamenMenu = ({ pages, closeDrawer }: Props) => {
  const navigate = useNavigate();
  const setMenuNavigate = useSetRecoilState(navigateTypeState);
  const handleClick = (to: string) => {
    closeDrawer();
    setMenuNavigate("menu");
    navigate(to);
  };
  return (
    <List disablePadding>
      {Object.keys(pages)
        .sort()
        .map((gamenId) => {
          const page = pages[gamenId];
          return (
            <Box key={gamenId}>
              <ListItem
                key={gamenId}
                button
                onClick={() => handleClick(page.nav)}
                sx={{ paddingLeft: "24px" }}
              >
                <ListItemText primary={page.label} />
              </ListItem>
              <Divider />
            </Box>
          );
        })}
    </List>
  );
};
